import { render, staticRenderFns } from "./DetailLection.vue?vue&type=template&id=5ed7cd3d&"
import script from "./DetailLection.vue?vue&type=script&lang=js&"
export * from "./DetailLection.vue?vue&type=script&lang=js&"
import style0 from "./DetailLection.vue?vue&type=style&index=0&id=5ed7cd3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports